import { Modal } from "antd";
import i18n from "i18next";

/**
 * =============================================================================
 * CONFIRMACION UNICA DEL PORTAL
 * =============================================================================
 * Un solo sitio decide como se pregunta antes de una accion irreversible. Antes
 * habia tres formas distintas -Popconfirm, Modal.confirm y ninguna- segun la
 * pantalla, y la mas peligrosa era justamente "ninguna": borrar una evaluacion
 * o finalizar una sesion con el paciente dentro de las gafas no preguntaba nada.
 *
 * Es una funcion de modulo, no un hook: la llaman manejadores sueltos y menus
 * que no son componentes. Por eso traduce con la instancia de i18next en vez de
 * con useTranslation.
 *
 * Modal.confirm es la variante estatica de antd, asi que NO hereda el
 * ConfigProvider del shell. No le hace falta: el tamano tactil de sus botones
 * en pantallas estrechas se lo dara la hoja de estilos global a traves de la
 * clase `revi-confirm`, cuando exista.
 * =============================================================================
 */

/**
 * @param {Object}   opciones
 * @param {string}   opciones.titulo       - la pregunta
 * @param {node}     opciones.consecuencia - que pasa si se acepta, nombrando el objeto
 * @param {string}   opciones.textoOk      - el verbo de la accion, nunca un "Aceptar"
 * @param {Function} opciones.onOk
 * @param {boolean}  [opciones.peligroso]  - false cuando la accion no destruye nada
 */
export function confirmar({
  titulo,
  consecuencia,
  textoOk,
  onOk,
  peligroso = true,
}) {
  return Modal.confirm({
    title: titulo,
    content: consecuencia,
    okText: textoOk,
    cancelText: i18n.t("common:actions.cancel"),
    okType: peligroso ? "danger" : "primary",
    // El foco entra en Cancelar: la tecla Intro no puede confirmar un borrado.
    autoFocusButton: "cancel",
    className: "revi-confirm",
    centered: true,
    onOk,
  });
}
